import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

const LoadMoreButton = ({ handleLoadNewPage, isLoading }) => (
  <Box justifyContent="center" pt={{ l: 2 }}>
    <Button onClick={handleLoadNewPage} isLoading={isLoading}>
      {s__('MediaCenter|Load more')}
    </Button>
  </Box>
);

export default LoadMoreButton;
